import RisksBlock from './RisksBlock';

export default RisksBlock;
